import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import IOSSwitch from '../../global/IOSSwitch';

interface SettingsBoxProps {
  title: string;
  description: string;
  button?: {
    text: string;
    onClick: () => void | Promise<void>;
    isLoading?: boolean;
    disabled?: boolean;
  };
  toggle?: {
    hidden?: boolean;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
  };
  children?: React.ReactNode;
}

const buttonStyle: SxProps<Theme> = {
  width: 'fit-content',
};

function SettingsBox({
  title,
  description,
  button,
  toggle,
  children,
}: SettingsBoxProps) {
  return (
    <Stack
      spacing={1}
      padding={2}
      borderRadius="5px"
      border={theme => `1px solid ${theme.palette.lightGrey.main}`}>
      <Box
        display="flex"
        flexDirection="row"
        gap={5}
        alignItems="end"
        justifyContent="space-between">
        <Stack spacing="5px">
          <Typography variant="h3">{title}</Typography>
          <Typography variant="body1">{description}</Typography>
        </Stack>
        {toggle && (
          <Box width={42}>
            {!toggle.hidden && (
              <IOSSwitch
                checked={toggle.checked}
                onChange={(_, checked) => toggle.onChange(checked)}
                disabled={toggle.disabled}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            )}
          </Box>
        )}
      </Box>
      {button && (
        <LoadingButton
          sx={buttonStyle}
          variant="light"
          onClick={button.onClick}
          loading={button.isLoading}
          disabled={button.disabled}>
          <span>{button.text}</span>
        </LoadingButton>
      )}
      {children}
    </Stack>
  );
}

export default SettingsBox;
